import React, { useState, useEffect, useContext } from 'react';
import { Grid, Typography, Link, Box } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
	GIVE_FEEDBACK,
	CDS_NO_DATA,
	CDS_NO_DATA_TEXT1,
	CDS_NO_DATA_TEXT2,
	CDS_NO_DATA_TEXT3,
	LEARN_MORE,
	YOUR_SEARCH_DATA,
	PROTIP_CDS,
	PROTIP_CDS_BASIC,
	CDS_GIVE_FEEDBACK,
	PROTIP_CDS_ATTR_LIST
} from 'constants/constant';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import fonts from 'constants/fonts';
import PropTypes from 'prop-types';
import { getBaseUrl, isBasicPersona } from 'helper/utils';
import { UserPortalContext } from 'context/appcontext';

const useStyles = makeStyles(() => ({
	proTipText: {
		fontFamily: fonts.Bogle_Regular,
		fontSize: '14px'
	},
	proTipContainer: {
		backgroundColor: '#F1F1F2',
		border: '1px solid #BABBBE',
		borderLeft: '4px solid #2E2F32',
		borderRadius: '4px',
		padding: '8px',
		paddingRight: '16px',
		paddingLeft: '0px'
	},
	regularText: {
		color: colors.DARK_GREY,
		fontFamily: fonts.Bogle_Regular,
		fontSize: '14px',
		fontStyle: 'normal',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontWeight: 400,
		lineHeight: 'normal'
	},
	hyperLinkText: {
		color: colors.LIGHTER_BLACK,
		fontFamily: fonts.Bogle_Regular,
		textDecoration: 'underline'
	},
	boldText: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: colors.DARK_GREY,
		fontFamily: fonts.Bogle_Regular,
		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: 700,
		lineHeight: 'normal'
	}
}));

function NothingFound({ searchKeyword, type = 'default' }) {
	const classes = useStyles();
	const [isAlert, setIsAlert] = useState(false);

	const portalUserContext = useContext(UserPortalContext);
	const isBasic = isBasicPersona(portalUserContext.customerType);

	// Must be lower case
	const triggerKeywords = PROTIP_CDS_ATTR_LIST;

	let searchInput = searchKeyword?.toLowerCase() || '';

	let displayType = type;

	useEffect(() => {
		if (triggerKeywords.some((el) => searchInput.includes(el))) {
			setIsAlert(true);
		}
	}, [searchKeyword]);

	return (
		<Box style={{ width: '100%' }}>
			{isAlert && (
				<Box>
					<Box className={classes.proTipContainer} display="flex" flexDirection="row">
						<Box
							display="flex"
							flexDirection="row"
							alignItems={displayType === 'full-width' ? 'center' : 'flex-start'}>
							<Box>
								<InfoOutlinedIcon
									style={{
										color: '#6D6E71',
										marginLeft: 10,
										marginRight: 10,
										marginTop: displayType === 'full-width' ? '6px' : 2
									}}
									fontSize="small"
								/>
							</Box>
							<Box className={classes.proTipText}>
								<Box
									sx={{
										justifyContent: displayType === 'full-width' ? 'space-between' : 'flex-start'
									}}
									display="flex"
									flexDirection={displayType === 'full-width' ? 'row' : 'column'}>
									<Box>{YOUR_SEARCH_DATA}</Box>
									<Box
										sx={{
											marginLeft: displayType === 'full-width' ? '4px' : '0px'
										}}>
										<Link
											className={classes.hyperLinkText}
											href={`${getBaseUrl()}${isBasic ? PROTIP_CDS_BASIC : PROTIP_CDS}`}
											target="_blank">
											{LEARN_MORE}
										</Link>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			)}
			<Box style={{ marginTop: '40px' }}>
				<Grid container justifyContent="space-between">
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<Typography className={classes.boldText}>{CDS_NO_DATA}</Typography>
						<Typography className={classes.regularText} style={{ marginTop: '10px' }}>
							{CDS_NO_DATA_TEXT1}
						</Typography>
						<Typography className={classes.regularText} style={{ marginBottom: '10px' }}>
							{CDS_NO_DATA_TEXT2}
						</Typography>
						<Typography className={classes.regularText}>
							{CDS_NO_DATA_TEXT3}
							<Link
								target="_blank"
								href={`${getBaseUrl()}/${CDS_GIVE_FEEDBACK}`}
								style={{ marginLeft: '2px', textDecoration: 'none', color: '#6245B7' }}>
								{GIVE_FEEDBACK}
							</Link>
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}

NothingFound.propTypes = {
	searchKeyword: PropTypes.string,
	type: PropTypes.string
};

export default NothingFound;
